<div class="topbar">
  <div class="topbar__inner">
    <div class="grid grid--va-middle">
      <div class="grid__box grid__box--size-min">
        <a class="link" href="/">
          <img class="topbar__logo" alt="beeline" src="assets/img/logo-horizontal.png" />
        </a>
      </div>

      <div class="grid__box">
        <app-breadcrumbs></app-breadcrumbs>
      </div>

      <div class="grid__box grid__box--size-min">
        <div *ngIf="isUserAuthorized">
          <app-topbar-notifications></app-topbar-notifications>
        </div>
      </div>
      <div class="grid__box grid__box--size-min">
        <div *ngIf="isUserAuthorized">
          <app-topbar-navigation></app-topbar-navigation>
        </div>
      </div>

      <div class="grid__box grid__box--size-min">
        <span *ngIf="isUserAuthorized">
          <span *ngIf="employee.last_name">{{ employee.last_name }} </span>
          <span *ngIf="employee.first_name">{{ $safeNavigationMigration(employee?.first_name) | slice: 0 : 1 | uppercase }}.</span>
          <span *ngIf="employee.patronymic_name">{{ employee.patronymic_name | slice: 0 : 1 | uppercase }}.</span>
        </span>
      </div>

      <div class="grid__box grid__box--size-min">
        <div class="grid grid--va-middle grid--gap-0" *ngIf="isUserAuthorized">
          <div class="grid__box grid__box--size-min">
            <app-icon [glyph]="'hd-exit'" [size]="'20'"></app-icon>
          </div>
          <div class="grid__box grid__box--size-min">
            <a class="link" (click)="logout()">Выйти</a>
          </div>
        </div>

        <div class="topbar__actions">
          <a class="link" *ngIf="isLegacyLoginVisible" routerLink="{{ '/' + AUTH_PATHS.login_legacy }}" [hidden]="isUserAuthorized"> Войти (old) </a>

          <a class="link" routerLink="{{ '/' + AUTH_PATHS.login }}" [hidden]="isUserAuthorized"> Войти </a>
        </div>
      </div>
    </div>
  </div>
</div>
